import { isNil } from 'lodash-es';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@mui/material';

import { useUserInfo } from 'queries/user-action/use-user-info';

import useStartTrialDialog from './hooks/use-start-trial-dialog';
import useStyles from './styles';

interface Props {
    size?: 'small' | 'regular';
    fullWidth?: boolean;
    className?: string;
}

const StartTrialButton: React.FC<Props> = ({ size = 'regular', fullWidth = false, className }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const { data: user, isLoading } = useUserInfo();
    const [startTrialDialog, openStartTrialDialog] = useStartTrialDialog();

    const handleClick = useCallback(() => {
        if (isLoading) {
            return;
        }

        if (isNil(user)) {
            return history.push('/trial/login');
        }

        const hasActiveTrialLicense = user.licenses.some(
            ({ isValid, licenseType }) => isValid && /trial/i.test(licenseType)
        );
        const hasActivePaidLicense = user.licenses.some(
            ({ isValid, licenseType }) => isValid && !/(trial|free)/i.test(licenseType)
        );

        if (!hasActiveTrialLicense && !hasActivePaidLicense) {
            openStartTrialDialog();
        } else {
            return history.push('/company/contacts');
        }
    }, [history, isLoading, openStartTrialDialog, user]);

    return (
        <>
            <Button
                disableElevation
                disableFocusRipple
                centerRipple
                variant="outlined"
                color="inherit"
                fullWidth={fullWidth}
                className={cx(
                    classes.root,
                    {
                        [classes._small]: size === 'small',
                        [classes._regular]: size === 'regular'
                    },
                    className
                )}
                onClick={handleClick}
            >
                {'Start free trial'}
            </Button>
            {startTrialDialog}
        </>
    );
};

export default StartTrialButton;
